import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router';
import PaymentComponent from '@/components/PaymentComponent.vue';
import SuccessPage from '@/components/SuccessPage.vue';
import LoginPage from '@/components/LoginPage.vue';
import LogoutPage from '@/components/LogoutPage.vue';
import PasswordReset from '@/components/PasswordReset.vue';
import AccountVerification from '@/components/AccountVerification.vue';
import AccountPage from '@/components/AccountPage.vue';
import RegistrationPage from '@/components/RegistrationPage.vue';
import RegistrationComplete from '@/components/RegistrationComplete.vue';
import ServicesFlow from './components/ServicesFlow.vue';
import OrderConfirmationPage from './components/OrderConfirmationPage.vue';
import PromoCodePage from '@/components/PromoCodePage.vue';
import AccountInfoPage from '@/components/AccountInfoPage.vue';
import EmailChangeVerification from '@/components/EmailChangeVerification.vue';
import RedeemGiftCard from '@/components/RedeemGiftCard.vue';
import GiftEntry from '@/components/GiftEntry.vue';
import RedeemMarketingGift from '@/components/RedeemMarketingGift.vue';
import KioskHome from '@/components/KioskHome.vue';
import KioskAdminPage from '@/components/KioskAdminPage.vue';
import KioskWaitPage from '@/components/KioskWaitPage.vue';
import { IS_KIOSK } from '@/config/kiosk';

// Importa Bootstrap e Popper.js
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import './assets/css/sweetalert.css'
import DocumentVerification from './components/DocumentVerification.vue';

// Aggiungi lo script del kit di Font Awesome
const fontAwesomeScript = document.createElement('script');
fontAwesomeScript.src = 'https://kit.fontawesome.com/434cbde3b3.js';
fontAwesomeScript.crossOrigin = 'anonymous';
document.head.appendChild(fontAwesomeScript);

const routes = [
    // In modalità kiosk la root apre la landing del totem; sul web resta /account.
    { path: '/', redirect: () => (IS_KIOSK ? '/kiosk' : '/account'), meta: { title: 'Elite Fitness' } },
    { path: '/kiosk', name: 'kiosk', component: KioskHome, meta: { title: 'Kiosk • Elite Fitness' } },
    { path: '/kiosk-admin', name: 'kiosk-admin', component: KioskAdminPage, meta: { title: 'Manutenzione • Elite Fitness' } },
    { path: '/kiosk-wait', name: 'kiosk-wait', component: KioskWaitPage, meta: { title: 'Registrazione • Elite Fitness' } },
    { 
        path: '/account', 
        name: 'account', 
        component: AccountPage,
        meta: { 
            requiresAuth: true,
            title: 'Area personale • Elite Fitness',
            description: 'Gestisci il tuo profilo, i servizi e i pagamenti Elite Fitness.',
        }
    },
    { path: '/checkout', name: 'checkout', component: PaymentComponent, meta: { title: 'Checkout • Elite Fitness', description: 'Acquista abbonamenti e servizi Elite Fitness in modo semplice e sicuro.' } },
    { path: '/success', name:'success', component: SuccessPage, meta: { title: 'Pagamento completato • Elite Fitness', description: 'Pagamento completato con successo. Troverai i dettagli nella tua email.' } },
    { path: '/login', name: 'login', component: LoginPage, meta: { title: 'Accedi • Elite Fitness', description: 'Accedi alla tua area personale Elite Fitness.' } },
    { path: '/logout', name: 'logout', component: LogoutPage, meta: { title: 'Logout • Elite Fitness', description: 'Stai uscendo dall’area personale Elite Fitness.' } },
    { path: '/password-reset', name: 'password-reset', component: PasswordReset, meta: { title: 'Recupera password • Elite Fitness', description: 'Recupera l’accesso al tuo account Elite Fitness.' } },
    { path: '/verify', name: 'verify', component: AccountVerification, meta: { title: 'Verifica account • Elite Fitness', description: 'Completa la verifica del tuo account per iniziare ad allenarti con noi.' } },
    { path: '/register', component: RegistrationPage, meta: { title: 'Registrati • Elite Fitness', description: 'Crea un account Elite Fitness in pochi passi.' } },
    { path: '/registration-complete', component: RegistrationComplete, meta: { title: 'Registrazione completata • Elite Fitness', description: 'La tua registrazione è avvenuta con successo.' } },
    { path: '/services-flow', component: ServicesFlow, meta: { title: 'Servizi • Elite Fitness', description: 'Scopri e acquista i servizi Elite Fitness.' } },
    { path: '/document-verification', component: DocumentVerification, meta: { title: 'Verifica documenti • Elite Fitness', description: 'Verifica la tua identità per completare l’attivazione dei servizi.' } },
    { path: '/order-confirmation', component: OrderConfirmationPage, meta: { title: 'Conferma ordine • Elite Fitness', description: 'Conferma e riepilogo del tuo ordine.' } },
    { path: '/promo-codes', name: 'promo-codes', component: PromoCodePage, meta: { title: 'Codici promozionali • Elite Fitness', description: 'Scopri i codici sconto disponibili per i servizi Elite Fitness.' } },
    { path: '/account-info', name: 'account-info', component: AccountInfoPage, meta: { title: 'Modifica informazioni • Elite Fitness', description: 'Modifica le tue informazioni personali e di contatto.', requiresAuth: true } },
    { path: '/verify-email-change', name: 'verify-email-change', component: EmailChangeVerification, meta: { title: 'Conferma modifica email • Elite Fitness', description: 'Conferma la modifica del tuo indirizzo email.' } },
    { path: '/redeem-gift-card', name: 'redeem-gift-card', component: RedeemGiftCard, meta: { title: 'Riscatta Gift Card • Elite Fitness', description: 'Inserisci il codice della tua gift card per accreditarla sul Wallet.', requiresAuth: true } },
    { path: '/gift-entry', name: 'gift-entry', component: GiftEntry, meta: { title: 'Regala un Ingresso Gratuito • Elite Fitness', description: 'Regala un ingresso gratuito a un amico. Puoi regalare 1 ingresso al mese.' } },
    { path: '/redeem-gift', name: 'redeem-gift', component: RedeemMarketingGift, meta: { title: 'Riscatta il tuo Regalo • Elite Fitness', description: 'Riscatta il servizio gratuito che ti è stato regalato.' } }
];

// Crea il router
const router = createRouter({
    // Anche nel kiosk usiamo la history HTML5: l'app è servita da un server HTTP
    // locale (http://127.0.0.1) dentro Electron, quindi routing e navigazioni a
    // path assoluti (es. href="/checkout?...") funzionano come sul web.
    history: createWebHistory(),
    routes,
});

// Aggiungi la guardia di navigazione
router.beforeEach((to, from, next) => {
    // In modalità kiosk /account (pagina "scarica l'app") non ha senso: home.
    if (IS_KIOSK && to.path === '/account') {
        next({ path: '/kiosk' });
        return;
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const token = localStorage.getItem('userToken');
        if (!token) {
            // Preserve the full path (including query) to return after login
            const returnUrl = encodeURIComponent(to.fullPath);
            next({ path: '/login', query: { returnUrl } });
            return;
        }
        
        // Verifica se il token è scaduto
        const tokenExpiration = localStorage.getItem('tokenExpiration');
        if (tokenExpiration) {
            const expirationTime = parseInt(tokenExpiration, 10);
            if (expirationTime && Date.now() > expirationTime) {
                // Token scaduto: rimuovi e reindirizza al login
                localStorage.removeItem('userToken');
                localStorage.removeItem('tokenExpiration');
                const returnUrl = encodeURIComponent(to.fullPath);
                next({ path: '/login', query: { returnUrl } });
                return;
            }
        }
        
        next();
    } else {
        next();
    }
});

// Aggiorna dinamicamente i meta tag OG/Twitter per ogni rotta
router.afterEach((to) => {
    const ensureMeta = (attr, key) => {
        let el = document.querySelector(`meta[${attr}='${key}']`);
        if (!el) {
            el = document.createElement('meta');
            el.setAttribute(attr, key);
            document.head.appendChild(el);
        }
        return el;
    };

    const setMetaContent = (attr, key, value) => {
        const el = ensureMeta(attr, key);
        el.setAttribute('content', value);
    };

    const title = to.meta.title || 'Elite Fitness';
    const description = to.meta.description || 'Prenota e gestisci i servizi Elite Fitness in pochi tap.';
    const image = 'https://account.elitefitness.it/social/og.png';
    const url = `https://account.elitefitness.it${to.fullPath || ''}`;

    document.title = title;
    setMetaContent('name', 'description', description);

    // OG
    setMetaContent('property', 'og:title', title);
    setMetaContent('property', 'og:description', description);
    setMetaContent('property', 'og:type', 'website');
    setMetaContent('property', 'og:site_name', 'Elite Fitness');
    setMetaContent('property', 'og:url', url);
    setMetaContent('property', 'og:image', image);
    setMetaContent('property', 'og:image:secure_url', image);
    setMetaContent('property', 'og:image:width', '1200');
    setMetaContent('property', 'og:image:height', '629');

    // Twitter
    setMetaContent('name', 'twitter:card', 'summary_large_image');
    setMetaContent('name', 'twitter:title', title);
    setMetaContent('name', 'twitter:description', description);
    setMetaContent('name', 'twitter:image', image);
});

const app = createApp(App);
app.use(router);
app.use(VueSweetalert2)
app.mount('#app');